import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageFeedbackEvent } from '../copilot/copilot.component';
import { ContentBlockType, CopilotMessage, CopilotTextContentBlock } from '../models/copilot.interface';

enum CopilotFeedbackRating {
  LIKE = 'liked',
  DISLIKE = 'disliked',
}

@Component({
  selector: 'sbnb-assistant-message',
  templateUrl: './assistant-message.component.html',
  styles: [
    `
      ::ng-deep sbnb-copy-to-clipboard .icon {
        color: var(--color-text-secondary) !important;
      }
      ::ng-deep sbnb-copy-to-clipboard .ctc__container:hover .icon {
        color: var(--color-text-primary) !important;
      }
    `,
  ],
})
export class AssistantMessageComponent {
  @Input() message!: CopilotMessage;
  @Input() isLast = false;
  @Input() requiresConfirmation = false;
  @Input() conversationUuid?: string;
  @Input() feedback?: 'liked' | 'disliked';

  @Output() feedbackClick = new EventEmitter<MessageFeedbackEvent>();
  @Output() confirmClick = new EventEmitter<void>();
  @Output() cancelClick = new EventEmitter<void>();

  CopilotFeedbackRating = CopilotFeedbackRating;
  ContentBlockType = ContentBlockType;

  get textContent(): string {
    if (!this.message.data || this.message.data.length === 0) {
      return '';
    }

    const textBlocks = this.message.data
      .filter((block) => block.type === ContentBlockType.Text)
      .map((block) => (block as CopilotTextContentBlock).content);

    return textBlocks.join('\n\n');
  }

  onFeedbackClick(type: CopilotFeedbackRating): void {
    if (!this.feedback) {
      this.feedbackClick.emit({
        messageUuid: this.message.uuid,
        rating: type as 'liked' | 'disliked',
      });
    }
  }

  onConfirmClick(): void {
    this.confirmClick.emit();
  }

  onCancelClick(): void {
    this.cancelClick.emit();
  }
}
